<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <FaqForm @submit-requested="submitRequested"></FaqForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import FaqForm from './FaqForm.vue'

  export default {
  components: { FaqForm },
  methods: {
    ...mapActions('faqs', ['postFaq']),
    submitRequested (input) {
      this.postFaq(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 